import { Outlet } from "react-router-dom";

const PaymentLinksParentPage = () => {
    return <Outlet />
}
export default PaymentLinksParentPage;
